export default function Go_Switch() {
  return (
    <div>
      <h1>Go_Switch </h1>
      <p>Conditswitch Statementions</p>
    </div>
  );
}
